import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _014a6699 = () => interopDefault(import('../pages/advantage/index.vue' /* webpackChunkName: "pages/advantage/index" */))
const _6ca72b9c = () => interopDefault(import('../pages/apply/index.vue' /* webpackChunkName: "pages/apply/index" */))
const _3b1ef7ae = () => interopDefault(import('../pages/cooperation/index.vue' /* webpackChunkName: "pages/cooperation/index" */))
const _5bf22b3e = () => interopDefault(import('../pages/countryIntroduction/index.vue' /* webpackChunkName: "pages/countryIntroduction/index" */))
const _1ae27a7b = () => interopDefault(import('../pages/hot/index.vue' /* webpackChunkName: "pages/hot/index" */))
const _5ec7753b = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _4c8421c6 = () => interopDefault(import('../pages/product/index.vue' /* webpackChunkName: "pages/product/index" */))
const _88bc0aa2 = () => interopDefault(import('../pages/studyTour/index.vue' /* webpackChunkName: "pages/studyTour/index" */))
const _564f9931 = () => interopDefault(import('../pages/success/index.vue' /* webpackChunkName: "pages/success/index" */))
const _05926976 = () => interopDefault(import('../pages/university/index.vue' /* webpackChunkName: "pages/university/index" */))
const _77a00033 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _456b5714 = () => interopDefault(import('../pages/user/index/index.vue' /* webpackChunkName: "pages/user/index/index" */))
const _3cdb55f9 = () => interopDefault(import('../pages/user/index/accommodation/index.vue' /* webpackChunkName: "pages/user/index/accommodation/index" */))
const _7d4bc314 = () => interopDefault(import('../pages/user/index/account/index.vue' /* webpackChunkName: "pages/user/index/account/index" */))
const _401a0806 = () => interopDefault(import('../pages/user/index/appointment/index.vue' /* webpackChunkName: "pages/user/index/appointment/index" */))
const _db7a6e8c = () => interopDefault(import('../pages/user/index/commission/index.vue' /* webpackChunkName: "pages/user/index/commission/index" */))
const _45b50117 = () => interopDefault(import('../pages/user/index/download/index.vue' /* webpackChunkName: "pages/user/index/download/index" */))
const _1cfd5abd = () => interopDefault(import('../pages/user/index/faq/index.vue' /* webpackChunkName: "pages/user/index/faq/index" */))
const _211ff59c = () => interopDefault(import('../pages/user/index/service/index.vue' /* webpackChunkName: "pages/user/index/service/index" */))
const _4ebafcbc = () => interopDefault(import('../pages/user/index/student/index.vue' /* webpackChunkName: "pages/user/index/student/index" */))
const _a748fa2e = () => interopDefault(import('../pages/user/index/training/index.vue' /* webpackChunkName: "pages/user/index/training/index" */))
const _62396ab2 = () => interopDefault(import('../pages/user/index/application/details.vue' /* webpackChunkName: "pages/user/index/application/details" */))
const _5af178a5 = () => interopDefault(import('../pages/user/index/order/details.vue' /* webpackChunkName: "pages/user/index/order/details" */))
const _a079b5dc = () => interopDefault(import('../pages/user/index/student/details.vue' /* webpackChunkName: "pages/user/index/student/details" */))
const _de3295ae = () => interopDefault(import('../pages/visa/index.vue' /* webpackChunkName: "pages/visa/index" */))
const _61e84bab = () => interopDefault(import('../pages/hot/details.vue' /* webpackChunkName: "pages/hot/details" */))
const _4079966b = () => interopDefault(import('../pages/news/details.vue' /* webpackChunkName: "pages/news/details" */))
const _605867e6 = () => interopDefault(import('../pages/university/details.vue' /* webpackChunkName: "pages/university/details" */))
const _1b960186 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/advantage",
    component: _014a6699,
    name: "advantage"
  }, {
    path: "/apply",
    component: _6ca72b9c,
    name: "apply"
  }, {
    path: "/cooperation",
    component: _3b1ef7ae,
    name: "cooperation"
  }, {
    path: "/countryIntroduction",
    component: _5bf22b3e,
    name: "countryIntroduction"
  }, {
    path: "/hot",
    component: _1ae27a7b,
    name: "hot"
  }, {
    path: "/news",
    component: _5ec7753b,
    name: "news"
  }, {
    path: "/product",
    component: _4c8421c6,
    name: "product"
  }, {
    path: "/studyTour",
    component: _88bc0aa2,
    name: "studyTour"
  }, {
    path: "/success",
    component: _564f9931,
    name: "success"
  }, {
    path: "/university",
    component: _05926976,
    name: "university"
  }, {
    path: "/user",
    component: _77a00033,
    children: [{
      path: "",
      component: _456b5714,
      name: "user-index"
    }, {
      path: "accommodation",
      component: _3cdb55f9,
      name: "user-index-accommodation"
    }, {
      path: "account",
      component: _7d4bc314,
      name: "user-index-account"
    }, {
      path: "appointment",
      component: _401a0806,
      name: "user-index-appointment"
    }, {
      path: "commission",
      component: _db7a6e8c,
      name: "user-index-commission"
    }, {
      path: "download",
      component: _45b50117,
      name: "user-index-download"
    }, {
      path: "faq",
      component: _1cfd5abd,
      name: "user-index-faq"
    }, {
      path: "service",
      component: _211ff59c,
      name: "user-index-service"
    }, {
      path: "student",
      component: _4ebafcbc,
      name: "user-index-student"
    }, {
      path: "training",
      component: _a748fa2e,
      name: "user-index-training"
    }, {
      path: "application/details",
      component: _62396ab2,
      name: "user-index-application-details"
    }, {
      path: "order/details",
      component: _5af178a5,
      name: "user-index-order-details"
    }, {
      path: "student/details",
      component: _a079b5dc,
      name: "user-index-student-details"
    }]
  }, {
    path: "/visa",
    component: _de3295ae,
    name: "visa"
  }, {
    path: "/hot/details",
    component: _61e84bab,
    name: "hot-details"
  }, {
    path: "/news/details",
    component: _4079966b,
    name: "news-details"
  }, {
    path: "/university/details",
    component: _605867e6,
    name: "university-details"
  }, {
    path: "/",
    component: _1b960186,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
